<template>

  <div>
    <div class="tabs">
      <a v-for="tab in tabs" :href="tab.href" role="tab" class="button mod-tab" @click="selectTab(tab)" :class="{ active : tab.isActive }" rel="nofollow">{{tab.name}}</a>
    </div>

    <div class="tab-content">
      <slot></slot>

      <div class="loader" :class="{ loading: loading }"></div>
    </div>
  </div>

</template>


<script>

  import Tab from './tab.vue'

  export default {

    data() {
      return {
        tabs: [],
        hash: window.location.hash,
        loading: false
      }
    },

    components: { 'tab' : Tab },

    created() {
      this.tabs = this.$children;
    },

    computed: {
      requested() {
        return this.hash.replace(/-/g, ' ').substring(1);
      }
    },


    methods: {
      selectTab(selected){
        //Event.emit('reset-animations');
        this.loading = true;

        setTimeout( () => {
          this.tabs.forEach(tab => {
            tab.isActive = (tab.name == selected.name)
          })
        }, 400 )

        setTimeout( () => { this.loading = false }, 800 )

      } 
    }

  }

</script>